import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbsenceStatusEnum } from '@qaroni-app/absences/types/absence-status.enum';

@Component({
  selector: 'qaroni-absence-status-preview',
  templateUrl: './absence-status-preview.component.html',
  styleUrls: ['./absence-status-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AbsenceStatusPreviewComponent {
  readonly status = input<AbsenceStatusEnum>(AbsenceStatusEnum.CREATED);

  get statusEnum(): typeof AbsenceStatusEnum {
    return AbsenceStatusEnum;
  }
}
